import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

import { centerToPosition } from '../shared-center-to-position/center-to-position';

export function generateFlight2Steps(
    flight1Count: number,
    turnStepCount: number,
    flight2Count: number,
    riserHeight: number,
    treadDepth: number,
    turnStartZ: number,
    config: IStairConfig,
    startIndex: number
): IStepGeometry[] {
    const steps: IStepGeometry[] = [];
    const sw: number = config.stairWidth;
    const isRight: boolean = config.turnDirection === 'right';
    const baseRiserIndex: number = flight1Count + turnStepCount;

    for (let j: number = 0; j < flight2Count; j++) {
        const stepY: number = (baseRiserIndex + j + 1) * riserHeight;

        // Desired world-space center of the step
        let cx: number;
        let cz: number;
        // Riser line j sits j·treadDepth past the turn edge; the tread runs one going behind it and
        // its nose overhangs the step below, so the board is centred (treadDepth − nose)/2 past it.
        const offset: number = j * treadDepth + (treadDepth - config.noseLength) / 2;
        if (isRight) {
            // Flight 2 goes +X from the turn zone right edge
            cx = sw + offset;
            cz = turnStartZ + sw / 2;
        } else {
            // Flight 2 goes -X from the turn zone left edge
            cx = -offset;
            cz = turnStartZ + sw / 2;
        }

        // Reverse renderer offset to get step.position
        const pos: { x: number; z: number } = centerToPosition(cx, cz, sw, treadDepth, config.noseLength);

        // RotY(90°) sends +Z → +X; RotY(-90°) sends +Z → -X
        const rotation: number = isRight ? 90 : -90;

        steps.push({
            index: startIndex + j,
            position: { x: pos.x, y: stepY, z: pos.z },
            treadWidth: sw,
            treadThickness: config.treadThickness,
            noseLength: config.noseLength,
            isWinder: false,
            isLanding: false,
            treadDepth,
            riserHeight,
            rotation,
        });
    }

    return steps;
}
